import React from 'react'
import { IIconProps } from 'Interfaces'

export function CalendarIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 16} height={props.height ?? 16} viewBox="0 0 24 24" fill={props.color ?? "currentColor"}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4615 1.84615H24V24H0V1.84615H5.53846V0H7.38462V1.84615H16.6154V0H18.4615V1.84615ZM7.38462 3.69231V5.53846H5.53846V3.69231H1.84615V22.1538H22.1538V3.69231H18.4615V5.53846H16.6154V3.69231H7.38462Z" />
            <path d="M5.53848 9.23071H3.69232V11.0769H5.53848V9.23071Z" />
            <path d="M7.38464 9.23071H9.2308V11.0769H7.38464V9.23071Z" />
            <path d="M12.9231 9.23071H11.0769V11.0769H12.9231V9.23071Z" />
            <path d="M14.7692 9.23071H16.6154V11.0769H14.7692V9.23071Z" />
            <path d="M20.3077 9.23071H18.4615V11.0769H20.3077V9.23071Z" />
            <path d="M18.4615 12.9231H20.3077V14.7693H18.4615V12.9231Z" />
            <path d="M16.6154 12.9231H14.7692V14.7693H16.6154V12.9231Z" />
            <path d="M11.0769 12.9231H12.9231V14.7693H11.0769V12.9231Z" />
            <path d="M9.2308 12.9231H7.38464V14.7693H9.2308V12.9231Z" />
            <path d="M3.69232 12.9231H5.53848V14.7693H3.69232V12.9231Z" />
            <path d="M5.53848 16.6154H3.69232V18.4615H5.53848V16.6154Z" />
            <path d="M7.38464 16.6154H9.2308V18.4615H7.38464V16.6154Z" />
            <path d="M12.9231 16.6154H11.0769V18.4615H12.9231V16.6154Z" />
            <path d="M14.7692 16.6154H16.6154V18.4615H14.7692V16.6154Z" />
            <path d="M20.3077 16.6154H18.4615V18.4615H20.3077V16.6154Z" />
        </svg>
    )
}
